var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterApplied(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.386 9.734A5.002 5.002 0 0110.416 3H4.094c-.423 0-.808.278-.989.715-.18.436-.125.953.142 1.327l5.004 6.986V14.5c0 .316.128.613.35.8l1.75 1.5c.265.229.62.263.916.094.298-.169.484-.515.484-.894v-3.972l1.635-2.294z",
    fill: "#0D2976"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 4,
    fill: "#D42A36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterApplied);
export default ForwardRef;